import CustomButton from 'components/Buttons/CustomButton'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalBody } from 'reactstrap'
import { toggleModalVerify } from './reportAttendanceSlice'
import { useSnackbar } from 'notistack'
import { editAttendance, verifyAttendance } from './reportAttendanceAction'
import { P } from 'components'
import { formatDateOnlyPMBV1, formatDatePMB } from 'utils/formatDate'

const ModalVerifyAttendance = ({ row, refetch }) => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { isOpenModalVerify } = useSelector((s) => s.reportAttendance)
  const toggle = () => dispatch(toggleModalVerify())
  const [loading, setLoading] = useState(false)

  const onSubmitEdit = async () => {
    setLoading(true)
    dispatch(
      verifyAttendance({
        ids: row?.map((e) => e?.id),
        status: 'VERIFIED',
      }),
    )
      .then((res) => {
        if (res?.error?.message) {
          throw res?.payload?.data?.message || res?.error?.message
        }

        toggle()
        refetch()
        enqueueSnackbar('Berhasil edit data absensi.', {
          variant: 'success',
        })
        setLoading(false)
      })
      .catch((err) => {
        enqueueSnackbar(err, {
          variant: 'error',
        })
        setLoading(false)
      })
  }

  return (
    <>
      <Modal
        centered
        isOpen={isOpenModalVerify}
        toggle={toggle}
        size="md"
        data-testid="attendance-report-modal-verify"
      >
        <ModalBody className="d-flex flex-column justify-content-center pt-4">
          <P size="regular" className="mb-2">
            Apakah Anda yakin untuk memverifikasi absensi ini?
          </P>
          <div className="mb-3">
            {row?.map((e, i) => {
              return (
                <P size="regular">
                  {i + 1}. {formatDateOnlyPMBV1(row?.createdAt)} -{' '}
                  {e?.verifiedprofile?.name}
                </P>
              )
            })}
          </div>
          <div className="d-flex justify-content-between gap-2 mt-3">
            <CustomButton
              color="primary"
              size="sm"
              onClick={toggle}
              block
              disabled={loading}
              className="btn-cancel"
              testId="attendance-report-modal-verify-cancel-button"
            >
              Batal
            </CustomButton>
            <CustomButton
              color="primary"
              size="sm"
              onClick={onSubmitEdit}
              block
              disabled={loading}
              testId="attendance-report-modal-verify-submit-button"
            >
              Verifikasi
            </CustomButton>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default ModalVerifyAttendance
